export default "__VITE_ASSET__Bt9i3KUi__"